import { Avatar, Box } from "@mui/material";
import React from "react";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { green, orange } from "@mui/material/colors";
import { Container } from "@mui/system";
// import Typewriter from "typewriter-effect";
import { Fade } from "react-awesome-reveal";
import service from "../assets/service.jpg";
import bussiness from "../assets/Business.png";

import Typewriter from "typewriter-effect";
import { Link } from "react-router-dom";

const Section = () => {
  return (
    <Container>
      <Box
        sx={[
          {
            display: "flex ",
            // flexDirection: "column",
            alignContent: "center",
            mt: "100px",
            // ml: { md: 10 },

            alignItems: "center",
          },
          (theme) => ({
            [theme.breakpoints.up("sm")]: {
              ml: 10,
            },
          }),
          (theme) => ({
            [theme.breakpoints.down("sm")]: {
              alignItems: "center",
              justifyContent: "center",
              display: "flex ",
              flexDirection: "column",
              mx: 2,
            },
          }),
        ]}
      >
        <Fade delay={1000} direction="left">
          <Box
            sx={{
              display: "flex ",
              flexDirection: "column",

              mt: "100px",
              textAlign: "center",
              alignItems: "center",
              // background: "black",
              justifyContent: "center",
            }}
          >
            {/* <Avatar
              alt="Worship"
              variant={"rounded"}
              sx={{ width: 60, height: 60 }}
              src={BusinessIcon}
            /> */}
            {/* <BusinessIcon className="h-36 w-36" /> */}
            <Typography
              sx={[
                {
                  color: "black",
                  fontSize: 26,
                  px: 2,
                },
                (theme) => ({
                  [theme.breakpoints.down("sm")]: {
                    fontSize: 30,
                    px: 1,
                  },
                }),
              ]}
              variant="h4"
            >
              Looking for professional services for your home or business?{" "}
              <br />
            </Typography>{" "}
            <Typography
              sx={[
                {
                  color: "black",

                  py: 3,
                  fontSize: 20,
                },
                (theme) => ({
                  [theme.breakpoints.down("sm")]: {
                    fontSize: 16,
                    px: 1,
                  },
                }),
              ]}
              variant="p"
            >
              <Typewriter
                options={{
                  strings:
                    "Give us a summary and we'll match  you with licensed pro in your neighborhood",
                  autoStart: true,
                  loop: true,
                }}
                // onInit={(typewriter) => {
                //   typewriter

                //     .typeString("   Worship. Word. Spirit")

                //     .pauseFor(5000)
                //     .deleteAll()
                //     // .typeString(" Worship. Word. Spirit")
                //     .start();
                // }}
              />
            </Typography>
            <Button
              sx={[
                {
                  background: "green",
                  my: 2,
                  px: 2,
                  py: 2,
                  fontSize: 16,
                  "&:hover": { background: green[600] },
                  fontWeight: 850,
                },
                (theme) => ({
                  [theme.breakpoints.down("sm")]: {
                    fontSize: 8,
                    px: 1,
                  },
                }),
              ]}
              variant="contained"
            >
              click here to start
            </Button>
          </Box>{" "}
        </Fade>
        <Fade delay={2000} direction="right">
          <Box
            sx={[
              {
                display: "flex ",
                flexDirection: "column",

                mt: "100px",

                alignItems: "center",
                // justifyContent: "center",
              },
              (theme) => ({
                [theme.breakpoints.down("sm")]: {
                  alignItems: "center",
                  justifyContent: "center",
                  display: "none",
                  flexDirection: "column",
                  mx: 2,
                },
              }),
            ]}
          >
            <Avatar
              alt="service"
              variant={"rounded"}
              sx={{ width: "50%", height: "50%" }}
              src={service}
            />
          </Box>
        </Fade>
      </Box>{" "}
      <Box
        sx={[
          {
            display: "flex ",
            // flexDirection: "column",
            alignContent: "center",
            mt: "100px",
            // ml: { md: 10 },

            alignItems: "center",
          },
          (theme) => ({
            [theme.breakpoints.up("sm")]: {
              ml: 10,
            },
          }),
          (theme) => ({
            [theme.breakpoints.down("sm")]: {
              alignItems: "center",
              justifyContent: "center",
              mx: 2,
              mt: 0,
            },
          }),
        ]}
      >
        <Fade delay={1000} direction="left">
          <Box
            sx={{
              display: "flex ",
              flexDirection: "column",

              mt: "100px",
              textAlign: "center",
              alignItems: "center",
              // background: "black",
              justifyContent: "center",
            }}
          >
            <Typography
              sx={[
                {
                  color: "black",
                  fontSize: 26,
                  px: 2,
                  textAlign: "center",
                },
                (theme) => ({
                  [theme.breakpoints.down("sm")]: {
                    fontSize: 30,
                    px: 1,
                  },
                }),
              ]}
              variant="p"
            >
              Want access to qualified leads to increase business traffic?
            </Typography>{" "}
            <Typography
              sx={[
                {
                  color: "black",

                  py: 1,
                  fontSize: 20,
                },
                (theme) => ({
                  [theme.breakpoints.down("sm")]: {
                    fontSize: 16,
                    px: 1,
                  },
                }),
              ]}
              variant="h6"
            >
              <Typewriter
                options={{
                  strings: "  We'll  connect you to customers....",
                  autoStart: true,
                  loop: true,
                }}
                // onInit={(typewriter) => {
                //   typewriter

                //     .typeString("   Worship. Word. Spirit")

                //     .pauseFor(5000)
                //     .deleteAll()
                //     // .typeString(" Worship. Word. Spirit")
                //     .start();
                // }}
              />
            </Typography>
            <Button
              sx={[
                {
                  background: "green",
                  my: 2,
                  px: 2,
                  py: 2,
                  fontSize: 16,
                  color: "white",
                  "&:hover": { background: orange[600] },
                  fontWeight: 850,
                },
                (theme) => ({
                  [theme.breakpoints.down("sm")]: {
                    fontSize: 8,
                    px: 1,
                  },
                }),
              ]}
              variant="contained"
            >
              <Link to="/register">click here to sign up</Link>
            </Button>
          </Box>{" "}
        </Fade>
        <Fade delay={2000} direction="right">
          <Box
            sx={[
              {
                display: "flex ",
                flexDirection: "column",

                mt: "100px",

                alignItems: "center",
                // justifyContent: "center",
              },
              (theme) => ({
                [theme.breakpoints.down("sm")]: {
                  alignItems: "center",
                  justifyContent: "center",
                  display: "none",
                  flexDirection: "column",
                  mx: 2,
                },
              }),
            ]}
          >
            <Avatar
              alt="Worship"
              variant={"rounded"}
              sx={{ width: "60%", height: "60%" }}
              src={bussiness}
            />
          </Box>
        </Fade>
      </Box>
    </Container>
  );
};

export default Section;
